import React from "react";
import { Card, Button } from "antd";
import GrayUserProfileImage from "../../images/gray-user-profile.svg";
import "./NoPeople.scss";
import ImportPeopleModal from "../ImportPeopleModal";
import { withRouter } from "react-router-dom";
import { FormattedMessage } from "react-intl";
// import ImportPeopleModal from '../ImportPeopleModal';
// import ImportBottomImage from '../images/import-bottom.svg';
import { UploadPeople } from "@/components/People";

class NoPeople extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      importPeopleModalVisible: false,
    };
  }
  importPeopleFormRef = (importPeopleForm) => {
    this.importPeopleForm = importPeopleForm;
  };
  handleUploadPeopleFromFile = (confirm) => {
    const form = this.importPeopleForm.props.form;

    form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return;
      }
      if (confirm) {
        const data = { fileName: this.props.fileName };
        if (values.groupId) data.groupId = values.groupId;
        this.props.uploadPeopleFromFileConfirm(data);
      } else {
        const file =
          values &&
          values.upload &&
          values.upload[0] &&
          values.upload[0].originFileObj
            ? values.upload[0].originFileObj
            : null;

        this.props.uploadPeopleFromFile(file);
      }
    });
  };
  handleCloseImportPeopleModalButtonClick = () => {
    this.setState((prevState) => ({
      importPeopleModalVisible: false,
    }));
  };
  handleShowImportPeopleModalButtonClick = () => {
    this.setState((prevState) => ({
      importPeopleModalVisible: true,
    }));
  };
  render() {
    const { importPeopleModalVisible } = this.state;
    const {
      handleAddPersonBtnClick,
      peopleUploaded,
      uplodPeopleError,
      uploadingPeopleFromFile,
      uploadedPeople,
      fetchedGroupId,
      location,
    } = this.props;

    return (
      <React.Fragment>
        <Card
          bodyStyle={{
            padding: 45,
          }}
          className="boxShadow1 no-people"
          style={{ maxWidth: 760, margin: "0 auto", height: 280 }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <h1
                style={{
                  fontSize: "2em",
                  marginBottom: "0.1rem",
                  fontWeight: 300,
                }}
              >
                {`${location.pathname}`.includes("/groups/") ? (
                  <FormattedMessage
                    id="NoPeopleAddedInGroup"
                    defaultMessage="You haven't added anyone to this group."
                  />
                ) : (
                  <FormattedMessage
                    id="NoPeopleAdded"
                    defaultMessage="You haven't added anyone yet."
                  />
                )}
              </h1>
              <p
                style={{
                  color: "#707070",
                  fontSize: "0.9em",
                  marginBottom: 30,
                }}
              >
                <FormattedMessage
                  id="AddPeopleOptions"
                  defaultMessage="Add people by using any of the options below."
                />
              </p>
              <Button
                data-dfs-people-id={"add-person-link"}
                onClick={handleAddPersonBtnClick}
                style={{ padding: 0, marginRight: 10 }}
                type="link"
              >
                <FormattedMessage
                  id="Button.AddPerson"
                  defaultMessage="Add person"
                />
              </Button>
              <Button
                data-dfs-people-id={"upload-people-link"}
                onClick={this.handleShowImportPeopleModalButtonClick}
                type="link"
              >
                <FormattedMessage
                  id="Button.ImportFile"
                  defaultMessage="Import from a file"
                />
              </Button>
            </div>
            <div>
              <img
                style={{ width: "100%" }}
                src={GrayUserProfileImage}
                alt="user profile"
              />
            </div>
          </div>
        </Card>
        <UploadPeople
          location={location || { pathname: "" }}
          fetchedGroupId={fetchedGroupId}
          visible={importPeopleModalVisible}
          onClose={this.handleCloseImportPeopleModalButtonClick}
        />
        {/*<ImportPeopleModal*/}
        {/*  visible={importPeopleModalVisible}*/}
        {/*  handleClose={this.handleCloseImportPeopleModalButtonClick}*/}
        {/*  handleOk={this.handleUploadPeopleFromFile}*/}
        {/*  wrappedComponentRef={this.importPeopleFormRef}*/}
        {/*  uploadedPeople={uploadedPeople}*/}
        {/*  uploadingPeopleFromFile={uploadingPeopleFromFile}*/}
        {/*  peopleUploaded={peopleUploaded}*/}
        {/*  uplodPeopleError={uplodPeopleError}*/}
        {/*  fetchedGroupId={fetchedGroupId}*/}
        {/*  location={location || { pathname: '' }}*/}
        {/*/>*/}
      </React.Fragment>
    );
  }
}

export default withRouter(NoPeople);
